export const newPfm = {
    enabled: false,
    _description: 'Enables new pfm feature',
    intelligent_insights: {
        enabled: false,
        _description: 'Enables intelligent insights',
    },
    intelligent_insights_detailed_breakdowns: {
        enabled: false,
        _description: 'Enables intelligent insights detailed breakdowns',
    },
};
